module.exports = "/images/invite-new-members.svg?0fed2c236b3bee43b992aa49a20fd1bc";